import JoyCrmIntegrationService, { JoyCrmIntegrationServiceFunction } from '../services/JoyCrmIntegrationService';
import ACClientData from '../objects/ACClientData';
import ACDealData from '../objects/ACDealData';
import { JoyField, isJoyFieldMap, isJoyFieldMapArray, isNumber, isString } from 'joy-core';
/**
 * Lookup clients that booked photosessions.
 * @param offset integer
 * @param limit integer
 * @param searchText A string
 */
export async function photoClientsSearch(offset, limit, searchText) {
    let data = new Map();
    data[JoyField.offset] = offset;
    data[JoyField.limit] = limit;
    if (isString(searchText)) {
        data[JoyField.text] = searchText;
    }
    const result = await JoyCrmIntegrationService.instance.call(JoyCrmIntegrationServiceFunction.photoClientsSearch, data);
    let length = result[JoyField.count];
    if (!isNumber(length)) {
        throw Error("Invalid response data received for 'photoClientsSearch'");
    }
    if (!isJoyFieldMapArray(result[JoyField.data])) {
        throw Error("Invalid response data received for 'photoClientsSearch'");
    }
    let dealsData = [];
    for (const element of result[JoyField.data]) {
        if (isJoyFieldMap(element[JoyField.user]) &&
            isJoyFieldMap(element[JoyField.data]) &&
            isString(element[JoyField.status])) {
            let client = new ACClientData(element[JoyField.user]);
            let deal = new ACDealData(element[JoyField.data]);
            let state = element[JoyField.status];
            if (client !== null && deal !== null && state !== null) {
                dealsData.push([client, deal, state]);
            }
        }
    }
    return [length, dealsData];
}
/**
 * Trigger sending a public album url to a customer.
 * @param email Email of the customer
 * @param groupId Identifier of the group where the album is located
 * @param albumId Identifier of the public album
 */
export async function sendAlbumUrl(email, groupId, albumId) {
    let data = new Map();
    data[JoyField.email] = email;
    data[JoyField.group] = groupId;
    data[JoyField.album] = albumId;
    await JoyCrmIntegrationService.instance.call(JoyCrmIntegrationServiceFunction.sendPublicAlbum, data);
}
//# sourceMappingURL=Utils.js.map